// extracted by mini-css-extract-plugin
export default {"main":"aa165e1da8","tit":"_576411f830","maintitle":"_4fc2d9a7fb","ylw":"_857a18f587","white":"_4ca5615fa7","mv_title":"ed72aa0329","mv_nc":"_951ce126c6","mv_in":"_4b375c47a3"};